{
  "1 à 5": "1 إلى 5",
  "A chassé le plus de bad vibes": "طرد أكبر عدد من الـbad vibes",
  "A chassé les boss": {
    "zero": "طرد الزعماء",
    "one": "طرد الزعيم",
    "two": "طرد الزعيمين",
    "few": "طرد الزعماء",
    "many": "طرد الزعماء",
    "other": "طرد الزعماء"
  },
  "A ramassé le plus de vibes": "جمع أكبر عدد من الـvibes",
  "A relevé l’équipe": "أنهض الفريق",
  "Agir": "الأفعال",
  "Agrès": "أدوات السيرك",
  "Alliés soignés": "حلفاء مُعالَجون",
  "Alt": "Alt",
  "Alt Gr": "Alt Gr",
  "Ambyss": "Ambyss",
  "Anneaux solaires": "حلقات شمسية",
  "Apprendre à jouer": "تعلّم اللعب",
  "Approche une bad vibe : tu tires tout seul": "اقترب من bad vibe: تُطلق تلقائيًا",
  "Appuie sur Entrée ou sur A pour rejoindre": "اضغط Enter أو A للانضمام",
  "Appuie…": "اضغط…",
  "Après chaque kick, trois étincelles qui transpercent.": "بعد كل kick، ثلاث شرارات تخترق.",
  "Après le dernier boss, la nuit continue": "بعد آخر زعيم، يستمر الليل",
  "Arc-en-ciel du drop": "قوس قزح الـdrop",
  "Assiettes chinoises": "الصحون الدوّارة",
  "Attire": "يجذب",
  "Aucun salon ne porte ce code": "لا توجد غرفة بهذا الرمز",
  "Automatique": "تلقائي",
  "Autre": "آخر",
  "Avant de lancer": "قبل البدء",
  "Avec tes amis": "مع أصدقائك",
  "B2B : {recipe}": "B2B: {recipe}",
  "Backstage": "الكواليس",
  "Bad vibes": "Bad vibes",
  "Bad vibes dissipées": "bad vibes مُبدَّدة",
  "Baisser le son": "خفض الصوت",
  "Balaie la foule de loin avec ses poi lumineux. Fragile.": "يكنس الحشد من بعيد بكرات البوي المضيئة. هشّ.",
  "Balaie un arc d'une ligne de lumière qui dissout les bad vibes.": "يكنس قوسًا بخطّ من الضوء يذيب الـbad vibes.",
  "Banane": "حقيبة الخصر",
  "Bas": "أسفل",
  "Baskets légères": "الحذاء الخفيف",
  "Bonnes ondes": "ذبذبات طيبة",
  "Boss": "الزعماء",
  "Boss vaincu": "هُزم الزعيم",
  "Boucle VJ": "حلقة VJ",
  "Boule à facettes": "كرة الديسكو",
  "Bouton {number}": "الزر {number}",
  "Boutons par défaut remis.": "أُعيدت الأزرار الافتراضية.",
  "Bras grands ouverts": "الذراعان المفتوحتان",
  "Break": "استراحة",
  "Brume du lac": "ضباب البحيرة",
  "Bug": "خلل",
  "Bâton de feu": "عصا النار",
  "Bâton du diable": "عصا الشيطان",
  "Caisson de basse": "مضخّم الباص",
  "Ce bouton garde son rôle, choisis-en un autre.": "هذا الزر يحتفظ بدوره، اختر غيره.",
  "Ce code est déjà pris, réessaie": "هذا الرمز مستخدم، حاول مجددًا",
  "Ce code n’est pas valide": "هذا الرمز غير صالح",
  "Ce que tu as vécu, ce que tu attendais, ce que tu changerais.": "ما عشته، وما كنت تتوقعه، وما كنت ستغيّره.",
  "Cerceaux": "أطواق",
  "Cette touche garde son rôle, choisis-en une autre.": "هذا المفتاح يحتفظ بدوره، اختر غيره.",
  "Chacun prend une place avec son clavier ou sa manette.": "يأخذ كل واحد مكانه بلوحة مفاتيحه أو يد التحكم.",
  "Chaque dash laisse ta traînée au sol deux mesures.": "كل dash يترك أثرك على الأرض لمقطعين.",
  "Charge": "اندفاع",
  "Choisi": "مُختارة",
  "Choisir": "اختر",
  "Choisir la scène": "اختر المسرح",
  "Choisir un piège": "اختر فخًّا",
  "Choisis d’abord le type de ton avis.": "اختر أولًا نوع رأيك.",
  "Choisis la scène": "اختر المسرح",
  "Choisis tes touches et tes boutons": "اختر مفاتيحك وأزرارك",
  "Choisis ton amélioration": "اختر تحسينك",
  "Choisis ton perso": "اختر شخصيتك",
  "Choix de la scène": "اختيار المسرح",
  "Choix du perso": "اختيار الشخصية",
  "Choix d’amélioration": "اختيار التحسين",
  "Classe": "فئة",
  "Classe précédente": "الفئة السابقة",
  "Classe suivante": "الفئة التالية",
  "Classe · {className}": "فئة · {className}",
  "Classes": "الفئات",
  "Clavier et souris": "لوحة المفاتيح والفأرة",
  "Clic droit": "نقرة يمنى",
  "Clic gauche": "نقرة يسرى",
  "Clic molette": "نقرة العجلة",
  "Code du salon": "رمز الغرفة",
  "Colle le code ici": "الصق الرمز هنا",
  "Connexion impossible ({message})": "تعذّر الاتصال ({message})",
  "Connexion perdue": "انقطع الاتصال",
  "Console de mixage": "طاولة المزج",
  "Contexte de la partie": "سياق المباراة",
  "Contrôles": "التحكم",
  "Copie impossible ici. Ton avis reste dans l’onglet GitHub.": "لا يمكن النسخ هنا. يبقى رأيك في تبويب GitHub.",
  "Copie impossible ici. Ton texte est sélectionné : copie-le à la main.": "لا يمكن النسخ هنا. نصّك محدَّد: انسخه يدويًا.",
  "Copier": "نسخ",
  "Copier le lien": "نسخ الرابط",
  "Copié dans le presse-papiers.": "نُسخ إلى الحافظة.",
  "Coupé": "مكتوم",
  "Croix": "الأسهم",
  "Crée un salon pour inviter tes amis, ou rejoins le leur avec son code.": "أنشئ غرفة لتدعو أصدقاءك، أو انضم إلى غرفتهم برمزها.",
  "Créer un salon": "إنشاء غرفة",
  "Ctrl": "Ctrl",
  "Ctrl droite": "Ctrl الأيمن",
  "Câble d'or": "الكابل الذهبي",
  "C’est plutôt": "إنه أقرب إلى",
  "Dash": "انقضاض",
  "Debout": "واقف",
  "Des spores, à porter à un géant": "أبواغ، لتُحمل إلى عملاق",
  "Deux bâtons frappent tout autour de toi à chaque temps.": "عصوان تضربان من حولك مع كل نبضة.",
  "Deux éventails tournent autour de toi sans jamais s’arrêter.": "مروحتان تدوران حولك بلا توقف.",
  "Deuxième souffle": "النفس الثاني",
  "Diabolo": "ديابولو",
  "Didacticiel": "الدرس التعليمي",
  "Double bâton": "العصا المزدوجة",
  "Double faisceau": "الشعاع المزدوج",
  "Double tempo": "الإيقاع المضاعف",
  "Downtempo, dub": "Downtempo، dub",
  "Droite": "يمين",
  "Drop": "Drop",
  "Débriefe ton set sur Discord": "احكِ عن حفلتك على Discord",
  "Début": "Home",
  "Défends le sound system jusqu’au lever du soleil.": "احمِ الـsound system حتى شروق الشمس.",
  "Défense": "دفاع",
  "Départ": "البداية",
  "Déplace-toi": "تحرّك",
  "Elle vide l'énergie de tout ce qui brille.": "تمتص طاقة كل ما يلمع.",
  "En attente de l’hôte": "بانتظار المضيف",
  "En attente de {players}": "بانتظار {players}",
  "En attente d’un joueur": "بانتظار لاعب",
  "En ligne": "على الإنترنت",
  "En ligne, la pause n’arrête pas le set : ton personnage reste immobile pendant que les autres jouent.": "على الإنترنت، الإيقاف لا يوقف الحفلة: تبقى شخصيتك ثابتة بينما يلعب الآخرون.",
  "Enceintes": "مكبرات",
  "Enceintes branchées": "مكبرات موصولة",
  "Entrée": "Enter",
  "Envoie le code ou le lien à tes amis, puis lance le set.": "أرسل الرمز أو الرابط إلى أصدقائك، ثم ابدأ الحفلة.",
  "Envoie une onde de basse sur chaque temps et repousse les bad vibes.": "يطلق موجة باص على كل نبضة ويدفع الـbad vibes بعيدًا.",
  "Envoyer sur GitHub": "إرسال على GitHub",
  "Espace": "مسافة",
  "Fais un dash": "انقضّ",
  "Fermer": "إغلاق",
  "Fin": "End",
  "Fin de partie": "نهاية المباراة",
  "Frappe autour": "يضرب من حولك",
  "Frappe devant": "يضرب أمامك",
  "Frappe loin": "يضرب بعيدًا",
  "Frisbee": "فريسبي",
  "Frisbees en passes": "تمريرات الفريسبي",
  "Full festival": "Full festival",
  "Fusion": "دمج",
  "Gauche": "يسار",
  "Glisse sur l’arène pour te déplacer": "اسحب على الساحة لتتحرّك",
  "Glisser son bouton": "اسحب زرّه",
  "Glisser sur l’arène": "اسحب على الساحة",
  "Goa des étoiles": "غوا النجوم",
  "Générique": "عام",
  "Haut": "أعلى",
  "Hôte": "المضيف",
  "Idée": "فكرة",
  "Il attire les bad vibes, puis les repousse d’une onde.": "يجذب الـbad vibes ثم يدفعها بموجة.",
  "Il enrôle les bad vibes en ronde autour de lui : elles prennent les coups.": "يجمع الـbad vibes في حلقة حوله: هي من تتلقى الضربات.",
  "Il filme la scène et éblouit doucement la zone de son écran.": "يصوّر المسرح ويبهر برفق المنطقة التي تواجهها شاشته.",
  "Il fonce droit sur la scène et bouscule qui se met en travers.": "يندفع مباشرة نحو المسرح ويدفع كل من يعترض طريقه.",
  "Il fonce sur tes vibes au sol, les vole, puis détale si tu le poursuis.": "ينقضّ على الـvibes الملقاة أرضًا، يسرقها، ثم يهرب إن طاردته.",
  "Il frappe en arc devant toi à chaque temps.": "يضرب في قوس أمامك مع كل نبضة.",
  "Il frappe à l’aller, revient soigner un allié.": "يضرب في الذهاب ويعود ليعالج حليفًا.",
  "Il ne va pas bien : reste à son contact une mesure pour l'aider.": "ليس بخير: ابقَ بجانبه مقطعًا موسيقيًا واحدًا لتساعده.",
  "Il reste loin et balance des bouteilles qui ralentissent qui les reçoit.": "يبقى بعيدًا ويقذف قوارير تبطّئ من تصيبه.",
  "Il s'accroche à toi et te ralentit jusqu'à ce qu'on le décroche.": "يتشبّث بك ويبطّئك حتى يزيحه أحد عنك.",
  "Il souffle, et tout ce qui est léger dérive.": "تنفخ، فينجرف كل ما هو خفيف.",
  "Il surgit de partout à la fois, faible seul mais jamais seul.": "يظهر من كل مكان في آن واحد، ضعيف وحده لكنه ليس وحده أبدًا.",
  "Il va plus loin et plus vite, puis revient soigner un allié.": "يذهب أبعد وأسرع، ثم يعود ليعالج حليفًا.",
  "Il veut couper le son avant l'heure.": "يريد قطع الصوت قبل الأوان.",
  "Il éteint les bonus de qui reste trop près : vise-le en priorité.": "يطفئ مكافآت كل من يقترب منه كثيرًا: صوّب عليه أولًا.",
  "Inser": "Insert",
  "Interruption": "انقطاع",
  "Inverser les sticks": "تبديل العصوين",
  "Invité": "ضيف",
  "Jambes de danseur": "ساقا الراقص",
  "Jauge": "مقياس",
  "Jeu complet": "اللعبة الكاملة",
  "Jeu web léger de survie coopérative dans un festival de psytrance.": "لعبة ويب خفيفة للبقاء التعاوني في مهرجان psytrance.",
  "Joindre le contexte": "إرفاق السياق",
  "Joue en continu": "يعمل دون توقف",
  "Jouer": "العب",
  "Joueur {number}": "اللاعب {number}",
  "Jusqu’à 4 joueurs": "حتى 4 لاعبين",
  "Kiff": "البهجة",
  "L'Arnaqueur": "المحتال",
  "L'Hygie": "هيجي",
  "L'Intolérant": "المتعصّب",
  "La Batterie à plat": "البطارية الفارغة",
  "La Forêt": "الغابة",
  "La Grenouille acide": "الضفدع الحمضي",
  "La Luxiole": "لوكسيول",
  "La musique s’arrête": "توقفت الموسيقى",
  "La partie a déjà commencé": "بدأت المباراة بالفعل",
  "La piste t’attend": "الحلبة بانتظارك",
  "La soirée d'ouverture": "ليلة الافتتاح",
  "Lance le set": "يبدأ الحفلة",
  "Lance ta spéciale": "أطلق مهارتك الخاصة",
  "Lancer la nuit": "ابدأ الليلة",
  "Lancer le festival": "ابدأ المهرجان",
  "Lancer le set": "ابدأ الحفلة",
  "Lancé sur le 1, il retombe sur les bad vibes et claque.": "يُرمى على الـ1، فيسقط على الـbad vibes ويفرقع.",
  "Langue": "اللغة",
  "Langues du jeu": "لغات اللعبة",
  "Laser": "ليزر",
  "Le Babacool": "الهيبي",
  "Le Bavard": "الثرثار",
  "Le Cercle acid": "دائرة الأسيد",
  "Le Circadien": "اليوماوي",
  "Le Collant": "اللزِج",
  "Le Coup de vent": "هبّة الريح",
  "Le Couvre-feu": "حظر التجوّل",
  "Le Céleste": "السماوي",
  "Le Dome": "القبّة",
  "Le Désagréable": "الفظّ",
  "Le Dôme chill": "قبّة الاسترخاء",
  "Le Fatigué": "النعسان",
  "Le Festivalier en détresse": "المحتفل المتعب",
  "Le Filmeur": "المصوِّر",
  "Le Jongleur": "المشعوذ",
  "Le Kiffeur": "المبتهج",
  "Le Mâle alpha": "ذكر ألفا",
  "Le Méprisant": "المتعالي",
  "Le Nounours": "نونورس",
  "Le Pogo": "راقص البوغو",
  "Le Poussin": "الكتكوت",
  "Le Random": "العشوائي",
  "Le Sportif": "الرياضي",
  "Le Sub": "الـSub",
  "Le Super fan": "المعجب الأول",
  "Le Tatoué": "الموشوم",
  "Le Veilleur aux lucioles": "حارس اليراعات",
  "Le Zombie": "الزومبي",
  "Le boss lâche une relique": "الزعيم يُسقط أثرًا",
  "Le formulaire GitHub est ouvert": "نموذج GitHub مفتوح",
  "Le jeu se recharge": "ستُعاد اللعبة",
  "Le lien avec les autres joueurs est coupé.": "انقطع الاتصال بالاعبين الآخرين.",
  "Le lève-tôt du petit matin : abats-le, il se relève une fois.": "مبكّر الفجر: أسقطه، فيقوم مرة واحدة.",
  "Le poser ailleurs": "ضعه في مكان آخر",
  "Le salon existe, mais vos réseaux n’arrivent pas à se joindre": "الغرفة موجودة، لكن شبكاتكم لا تستطيع الاتصال ببعضها",
  "Le set continue": "الحفلة مستمرة",
  "Le set est allé au bout, puis le sound system a tenu {duration} de sans-fin. On y retourne ?": "وصلت الحفلة إلى نهايتها، ثم صمد الـsound system {duration} في الوضع اللانهائي. نعيدها؟",
  "Le set reprend là où tu l’as laissé.": "تستأنف الحفلة من حيث توقفت.",
  "Le set se joue en paysage.": "تُلعب الحفلة بالوضع الأفقي.",
  "Le set s’arrête pour tout le monde plutôt que de continuer de travers. Le rapport est prêt pour « Ton avis ».": "تتوقف الحفلة للجميع بدل أن تستمر وهي غير متزامنة. التقرير جاهز في «رأيك».",
  "Le set s’arrête pour toute l’équipe, sans score : chacun peut changer de perso.": "تتوقف الحفلة للفريق كله، بلا نقاط: يمكن لكل واحد تغيير شخصيته.",
  "Le set va jusqu’au dernier boss, puis la nuit repart : elle s’arrête quand vous tombez.": "تمتد الحفلة حتى آخر زعيم، ثم ينطلق الليل من جديد: ينتهي حين تسقطون.",
  "Le soleil se lève sur le dancefloor. Le sound system a tenu toute la nuit.": "تشرق الشمس على حلبة الرقص. صمد الـsound system طوال الليل.",
  "Le sound system tient bon, mais les bad vibes ont vidé la piste. On se relève et on y retourne ?": "الـsound system صامد، لكن الـbad vibes أفرغت الحلبة. ننهض ونعيدها؟",
  "Le totem envoie une onde sur chaque kick.": "يطلق الطوطم موجة على كل kick.",
  "Les autres scènes suivent : à chaque sunrise, l’équipe choisit sa sortie.": "تليه المسارح الأخرى: عند كل شروق، يختار الفريق مخرجه.",
  "Les bad vibes ont eu raison du sound system. On rebranche et on y retourne ?": "تغلّبت الـbad vibes على الـsound system. نعيد التوصيل ونعيدها؟",
  "Les bad vibes qu’il traverse encaissent plus de coups.": "الـbad vibes التي يعبرها تتلقى ضربات أقوى.",
  "Les bad vibes y ralentissent": "تتباطأ الـbad vibes هناك",
  "Les bad vibes y sont marquées": "تُوسَم الـbad vibes هناك",
  "Les deux versions de la partie ont divergé": "خرجت نسختا المباراة عن التزامن",
  "Les joueurs": "اللاعبون",
  "Les lucioles veillent sur toi": "اليراعات تسهر عليك",
  "Les pièges freinent les bad vibes": "الفخاخ تُبطئ الـbad vibes",
  "Les quatre scènes, d’un chemin à l’autre": "المسارح الأربعة، من درب إلى درب",
  "Libre": "فارغة",
  "Lien copié, envoie-le à tes amis.": "نُسخ الرابط، أرسله إلى أصدقائك.",
  "Lien sélectionné : copie-le avec Ctrl+C.": "الرابط محدَّد: انسخه بـ Ctrl+C.",
  "Line-up": "Line-up",
  "Lourd et sûr de lui, il pousse ton matériel et encaisse moitié moins de face : prends-le à revers.": "ثقيل وواثق بنفسه، يدفع معدّاتك ويتلقى نصف الضرر من الأمام: باغته من الخلف.",
  "Lumière traversante": "الضوء الخارق",
  "Légendaire": "أسطورية",
  "L’Avatar": "الأفاتار",
  "L’Enraciné": "المتجذّر",
  "L’after": "ما بعد الحفلة",
  "L’hôte a fermé le salon": "أغلق المضيف الغرفة",
  "L’hôte a quitté le set": "غادر المضيف الحفلة",
  "L’hôte choisit la scène": "المضيف يختار المسرح",
  "L’équipe": "الفريق",
  "Machine à fumée": "آلة الدخان",
  "Main libre": "يد فارغة",
  "Main stage": "Main stage",
  "Maj": "Shift",
  "Maj droite": "Shift الأيمن",
  "Maj+Tab": "Shift+Tab",
  "Manette": "يد التحكم",
  "Manette {number}": "يد التحكم {number}",
  "Marcher au stick droit, viser au gauche": "المشي بالعصا اليمنى والتصويب باليسرى",
  "Marque": "يَسِم",
  "Menu de pause": "قائمة الإيقاف",
  "Menu principal": "القائمة الرئيسية",
  "Mode calme": "الوضع الهادئ",
  "Mode calme, commandes, langue": "الوضع الهادئ، التحكم، اللغة",
  "Mode de jeu": "وضع اللعب",
  "Molette": "العجلة",
  "Molette ↑": "العجلة ↑",
  "Molette ↓": "العجلة ↓",
  "Monocycle": "الدراجة الأحادية",
  "Monocycle filant": "الدراجة الخاطفة",
  "Monocycle réparateur": "الدراجة المُصلِحة",
  "Monter le son": "رفع الصوت",
  "Montée": "تصاعد",
  "Musique et effets": "الموسيقى والمؤثرات",
  "Même écran": "الشاشة نفسها",
  "Même écran ou en ligne": "الشاشة نفسها أو على الإنترنت",
  "Ne vise pas, il danse : sa bonne humeur frappe tout autour de lui et fait tirer plus vite.": "لا يصوّب، بل يرقص: مرحه يضرب كل ما حوله ويجعل الجميع يطلقون أسرع.",
  "Niv. {level}": "مس. {level}",
  "Niveau": "المستوى",
  "Niveau supérieur": "مستوى جديد",
  "Niveau {level}": "المستوى {level}",
  "Niveau {level} : {vibes} vibes sur {next}": {
    "zero": "المستوى {level}: {vibes} من {next} vibes",
    "one": "المستوى {level}: {vibes} من {next} vibes",
    "two": "المستوى {level}: {vibes} من {next} vibes",
    "few": "المستوى {level}: {vibes} من {next} vibes",
    "many": "المستوى {level}: {vibes} من {next} vibes",
    "other": "المستوى {level}: {vibes} من {next} vibes"
  },
  "Niveau {level} sur {max}": "المستوى {level} من {max}",
  "Nom": "الاسم",
  "Nom du joueur {number}": "اسم اللاعب {number}",
  "Non": "لا",
  "Nouveau": "جديد",
  "Nouveau record !": "رقم قياسي جديد!",
  "Nova": "Nova",
  "Ola": "الموجة",
  "Ola déchaînée": "الموجة العاتية",
  "Ola sans fin": "الموجة اللانهائية",
  "Oui": "نعم",
  "Page ↑": "Page ↑",
  "Page ↓": "Page ↓",
  "Palier {tier} / {count}": "المرحلة {tier} / {count}",
  "Palier {tier}, drop": "المرحلة {tier}، drop",
  "Par où commence la nuit ?": "من أين تبدأ الليلة؟",
  "Partie interrompue": "توقفت المباراة",
  "Pas chassé": "الخطوة المنزلقة",
  "Pas de compte GitHub ? Copie ton avis pour l’envoyer autrement.": "ليس لديك حساب GitHub؟ انسخ رأيك لترسله بطريقة أخرى.",
  "Pas de réponse : réessaie, ou vérifie le code": "لا رد: حاول مجددًا، أو تحقق من الرمز",
  "Pas sur GitHub ?": "لست على GitHub؟",
  "Passe dans les coulisses sur Discord": "تعال إلى الكواليس على Discord",
  "Pause": "إيقاف",
  "Pavé {number}": "Num {number}",
  "Phrases tenues": "الجمل الصامدة",
  "Piège précédent": "الفخ السابق",
  "Piège suivant": "الفخ التالي",
  "Pièges": "الفخاخ",
  "Place {place} sur {slots}": "الخانة {place} من {slots}",
  "Pluie de diabolos": "مطر الديابولو",
  "Plus aucun signe de l’hôte depuis {seconds} secondes.": {
    "zero": "لا أثر للمضيف.",
    "one": "لا أثر للمضيف منذ ثانية.",
    "two": "لا أثر للمضيف منذ ثانيتين.",
    "few": "لا أثر للمضيف منذ {seconds} ثوانٍ.",
    "many": "لا أثر للمضيف منذ {seconds} ثانية.",
    "other": "لا أثر للمضيف منذ {seconds} ثانية."
  },
  "Plus de place pour un piège : reprends-en un": "لا مكان لفخ آخر: استرجع واحدًا",
  "Plus personne debout": "لم يبقَ أحد واقفًا",
  "Portée": "المدى",
  "Pose ton mot sur Discord": "اترك كلمتك على Discord",
  "Pose un piège": "ضع فخًّا",
  "Poser le piège": "ضع الفخ",
  "Poser un piège à ses pieds": "ضع فخًّا عند قدميك",
  "Pour rejouer ta partie à l’identique": "لإعادة مباراتك كما هي تمامًا",
  "Progressive": "Progressive",
  "Projecteur de poursuite": "الكشّاف المتتبّع",
  "Prêt": "جاهز",
  "Prête": "جاهزة",
  "Psychill, ambient": "Psychill، ambient",
  "Psytrance full-on": "Psytrance full-on",
  "Pumpui": "Pumpui",
  "Quelle nuit !": "يا لها من ليلة!",
  "Qui monte sur la piste ce soir ?": "من سيصعد إلى الحلبة الليلة؟",
  "Quitter": "غادر",
  "Quitter la partie": "مغادرة المباراة",
  "Quitter le salon": "مغادرة الغرفة",
  "Quitter le set ?": "مغادرة الحفلة؟",
  "Raconte-nous ta soirée": "احكِ لنا عن ليلتك",
  "Ralentit": "يُبطئ",
  "Rallonge": "سلك التمديد",
  "Ramasse les vibes": "اجمع الـvibes",
  "Rang {rank}": "الرتبة {rank}",
  "Rang {rank} sur {max}": "الرتبة {rank} من {max}",
  "Rare": "نادرة",
  "Recharge": "إعادة الشحن",
  "Recharge la page": "أعد تحميل الصفحة",
  "Record : {score}": "الرقم القياسي: {score}",
  "Recrute tes roadies sur Discord": "اجمع فريقك على Discord",
  "Rejoindre": "انضم",
  "Rejouer": "العب مجددًا",
  "Relique": "أثر",
  "Relis ton avis dans le nouvel onglet, puis publie-le. Il te faut un compte GitHub.": "راجع رأيك في التبويب الجديد ثم انشره. تحتاج إلى حساب GitHub.",
  "Remettre par défaut": "استعادة الافتراضي",
  "Remplace {weapon}": "يستبدل {weapon}",
  "Remplis ta jauge de vibes, puis choisis une amélioration": "املأ مقياس الـvibes ثم اختر تحسينًا",
  "Repousse": "يدفع",
  "Reprendre": "استئناف",
  "Reprendre : {trap}": "استرجاع: {trap}",
  "Reste deux mesures pour brancher": "بقي مقطعان للتوصيل",
  "Reste près d’une enceinte pour la brancher": "ابقَ قرب مكبّر لتوصله",
  "Reste quatre mesures pour brancher": "بقيت أربعة مقاطع للتوصيل",
  "Reste trois mesures pour brancher": "بقيت ثلاثة مقاطع للتوصيل",
  "Reste une mesure pour brancher": "بقي مقطع واحد للتوصيل",
  "Reste zéro mesure pour brancher": "لم يبقَ أي مقطع للتوصيل",
  "Reste {bars} mesures pour brancher": {
    "zero": "لم يبقَ أي مقطع للتوصيل",
    "one": "بقي مقطع واحد للتوصيل",
    "two": "بقي مقطعان للتوصيل",
    "few": "بقيت {bars} مقاطع للتوصيل",
    "many": "بقي {bars} مقطعًا للتوصيل",
    "other": "بقي {bars} مقطع للتوصيل"
  },
  "Rester": "البقاء",
  "Retour": "رجوع",
  "Retour arrière": "Backspace",
  "Retour au perso": "العودة إلى الشخصية",
  "Retour au salon": "عودة للغرفة",
  "Retour au salon ?": "عودة للغرفة؟",
  "Retour au titre": "عودة للرئيسية",
  "Ruban arc-en-ciel": "شريط قوس قزح",
  "Réessayer": "أعد المحاولة",
  "Réglages": "الإعدادات",
  "Salon": "الغرفة",
  "Salon en ligne": "غرفة على الإنترنت",
  "Salon local": "غرفة محلية",
  "Salon plein": "الغرفة ممتلئة",
  "Sans fin": "بلا نهاية",
  "Sans lui, le sound system s’éteint.": "من دونه، ينطفئ الـsound system.",
  "Sans strobos, secousses ni halos forts": "بلا ومضات ولا اهتزاز ولا هالات قوية",
  "Sans tenir le tir": "دون الضغط المستمر",
  "Score": "النقاط",
  "Scène": "المسرح",
  "Scène du départ": "مسرح البداية",
  "Scènes": "المسارح",
  "Se déplacer": "تحرّك",
  "Ses bulles de blabla s'affichent et masquent un bout de ton écran.": "تظهر فقاعات ثرثرته وتحجب جزءًا من شاشتك.",
  "Ses zones freinent les bad vibes et soignent tes alliés.": "مناطقه تُبطئ الـbad vibes وتعالج حلفاءك.",
  "Soigne": "يعالج",
  "Soigne, répare la scène et relève ses amis.": "تعالج، وتصلح المسرح، وتنهض بأصدقائها.",
  "Soin": "علاج",
  "Son": "الصوت",
  "Son bâillement se propage autour de lui, puis il s'endort sur place.": "ينتشر تثاؤبه من حوله، ثم ينام في مكانه.",
  "Son des coups": "صوت الضربات",
  "Sono de référence": "النظام المرجعي",
  "Souffle un cône de brume qui balaie la piste, soigne sur chaque temps et ralentit les bad vibes.": "ينفخ مخروطًا من الضباب يكنس الحلبة، ويعالج على كل نبضة ويبطّئ الـbad vibes.",
  "Souris": "الفأرة",
  "Spéciale": "الخاصة",
  "Spéciale XXL": "الخاصة XXL",
  "Stick droit": "العصا اليمنى",
  "Stick gauche": "العصا اليسرى",
  "Sub renforcé": "Sub مُعزَّز",
  "Sunrise": "الشروق",
  "Sunrise !": "الشروق!",
  "Sur le drop, il traverse tout l’écran et marque tout.": "في الـdrop، يعبر الشاشة كلها ويَسِم كل شيء.",
  "Sur le drop, une pluie de diabolos tombe sur tout l’écran.": "في الـdrop، يهطل مطر من الديابولو على الشاشة كلها.",
  "Ta Ola frappe deux fois plus fort.": "تضرب موجتك بقوة مضاعفة.",
  "Ta Ola frappe plus fort.": "تضرب موجتك بقوة أكبر.",
  "Ta Ola frappe trois fois plus fort.": "تضرب موجتك بثلاثة أضعاف القوة.",
  "Ta spéciale frappe deux fois plus fort.": "تضرب مهارتك الخاصة بقوة مضاعفة.",
  "Ta spéciale frappe plus fort.": "تضرب مهارتك الخاصة بقوة أكبر.",
  "Ta spéciale frappe trois fois plus fort.": "تضرب مهارتك الخاصة بثلاثة أضعاف القوة.",
  "Ta spéciale revient bien plus vite.": "تعود مهارتك الخاصة أسرع بكثير.",
  "Ta spéciale revient plus vite.": "تعود مهارتك الخاصة أسرع.",
  "Ta spéciale revient presque aussitôt.": "تعود مهارتك الخاصة على الفور تقريبًا.",
  "Ta spéciale revient presque en continu.": "تعود مهارتك الخاصة دون توقف تقريبًا.",
  "Tactile": "لمس",
  "Talkie-walkie": "جهاز اللاسلكي",
  "Temps": "الوقت",
  "Tes agrès : {places}": "أدواتك: {places}",
  "Tes pièges font deux fois et demie plus de dégâts.": "تُحدث فخاخك ضررًا أكبر بمرتين ونصف.",
  "Tes pièges font deux fois plus de dégâts.": "تُحدث فخاخك ضعف الضرر.",
  "Tes pièges font plus de dégâts.": "تُحدث فخاخك ضررًا أكبر.",
  "Tes pièges frappent fort et loin, et tes loots abondent.": "تضرب فخاخك بقوة وبعيدًا، وتنهال عليك الغنائم.",
  "Tes pièges frappent plus fort et couvrent plus de piste.": "تضرب فخاخك بقوة أكبر وتغطي مساحة أوسع من الحلبة.",
  "Tes tirs font deux fois plus de dégâts.": "تُحدث طلقاتك ضعف الضرر.",
  "Tes tirs font nettement plus de dégâts.": "تُحدث طلقاتك ضررًا أكبر بكثير.",
  "Tes tirs font plus de dégâts.": "تُحدث طلقاتك ضررًا أكبر.",
  "Tes tirs traversent deux bad vibes de plus.": "تخترق طلقاتك اثنتين إضافيتين من الـbad vibes.",
  "Tes tirs traversent quatre bad vibes de plus.": "تخترق طلقاتك أربعًا إضافية من الـbad vibes.",
  "Tes tirs traversent six bad vibes de plus.": "تخترق طلقاتك ستًّا إضافية من الـbad vibes.",
  "Tes tirs vont plus vite, traversent plus et frappent fort.": "طلقاتك أسرع، تخترق أكثر وتضرب بقوة.",
  "Tient la ligne et attire les bad vibes. Lent.": "يصمد في الصف ويجذب الـbad vibes. بطيء.",
  "Tir automatique": "إطلاق تلقائي",
  "Tire": "أطلق",
  "Tire sur les doubles croches {steps}": "يطلق على النغمات {steps}",
  "Tire sur les doubles croches {steps}, une mesure sur {bars}": {
    "zero": "يطلق على النغمات {steps}",
    "one": "يطلق على النغمات {steps}، في كل مقطع",
    "two": "يطلق على النغمات {steps}، مقطعًا من كل اثنين",
    "few": "يطلق على النغمات {steps}، مقطعًا من كل {bars}",
    "many": "يطلق على النغمات {steps}، مقطعًا من كل {bars}",
    "other": "يطلق على النغمات {steps}، مقطعًا من كل {bars}"
  },
  "Tirer": "أطلق",
  "Toi": "أنت",
  "Toi · hôte": "أنت · المضيف",
  "Ton Kiff au max double la force de ta bonne humeur.": "بهجتك في أقصاها تضاعف قوة مرحك.",
  "Ton Kiff fait frapper ta bonne humeur nettement plus fort.": "بهجتك تجعل مرحك يضرب بقوة أكبر بوضوح.",
  "Ton Kiff fait frapper ta bonne humeur plus fort.": "بهجتك تجعل مرحك يضرب بقوة أكبر.",
  "Ton aura s’élargit nettement.": "تتّسع هالتك بوضوح.",
  "Ton aura s’élargit.": "تتّسع هالتك.",
  "Ton aura s’étend de moitié.": "تتّسع هالتك بمقدار النصف.",
  "Ton avis": "رأيك",
  "Ton avis sera public sur GitHub. N’y mets rien de personnel.": "سيكون رأيك علنيًا على GitHub. لا تضع فيه شيئًا شخصيًا.",
  "Ton dash revient bien plus vite.": "يعود انقضاضك أسرع بكثير.",
  "Ton dash revient nettement plus vite.": "يعود انقضاضك أسرع بوضوح.",
  "Ton dash revient plus vite.": "يعود انقضاضك أسرع.",
  "Ton message était trop long pour le lien, sa fin a été coupée. Copie-le en entier pour le coller sur GitHub.": "كانت رسالتك أطول من الرابط فقُطع آخرها. انسخها كاملة لتلصقها على GitHub.",
  "Ton navigateur a bloqué le nouvel onglet. Réessaie, ou copie ton avis pour ne pas le perdre.": "حظر متصفحك التبويب الجديد. حاول مجددًا، أو انسخ رأيك كي لا يضيع.",
  "Ton onglet a pris trop de retard.": "تأخّر تبويبك كثيرًا.",
  "Totem": "طوطم",
  "Totem sono": "طوطم الصوت",
  "Touche le bouton de ta spéciale": "المس زرّ مهارتك الخاصة",
  "Touche le bouton du dash": "المس زرّ الانقضاض",
  "Touche le bouton du piège pour le poser": "المس زرّ الفخ لتضعه",
  "Touche le bouton d’un piège pour le poser à tes pieds": "المس زرّ فخ لتضعه عند قدميك",
  "Toucher": "المس",
  "Toucher son bouton": "المس زرّه",
  "Touches par défaut remises.": "أُعيدت المفاتيح الافتراضية.",
  "Toujours là : Start pour la pause, la croix pour les gestes, A et B dans les menus.": "متاحة دائمًا: Start للإيقاف، وأزرار الأسهم للإيماءات، وA وB في القوائم.",
  "Toujours là : Échap pour la pause, 1 à 5 pour les pièges, les flèches et Entrée dans les menus.": "متاحة دائمًا: Esc للإيقاف، و1 إلى 5 للفخاخ، والأسهم وEnter في القوائم.",
  "Tourne ton téléphone": "أدر هاتفك",
  "Trois cerceaux, chacun frappe comme ta spéciale.": "ثلاثة أطواق، كل منها يضرب مثل مهارتك الخاصة.",
  "Trouve ton crew": "اعثر على جماعتك",
  "Tu as rejoint le salon {code}.": "انضممت إلى الغرفة {code}.",
  "Tu attires les vibes de bien plus loin.": "تجذب الـvibes من مسافة أبعد بكثير.",
  "Tu attires les vibes de plus loin.": "تجذب الـvibes من مسافة أبعد.",
  "Tu attires les vibes de très loin.": "تجذب الـvibes من مسافة بعيدة جدًا.",
  "Tu attires les vibes, tires plus et frappes plus fort.": "تجذب الـvibes، وتطلق أكثر، وتضرب بقوة أكبر.",
  "Tu deviens plus solide et tu glisses plus vite.": "تصبح أصلب وتنزلق أسرع.",
  "Tu fais venir les porteurs de loot deux fois plus souvent.": "يأتي حاملو الغنائم ضعف المرات.",
  "Tu fais venir les porteurs de loot plus souvent.": "يأتي حاملو الغنائم أكثر.",
  "Tu fais venir les porteurs de loot trois fois plus souvent.": "يأتي حاملو الغنائم ثلاثة أضعاف المرات.",
  "Tu files plus vite ; ta traînée freine plus et soigne mieux.": "تنطلق أسرع، وأثرك يُبطئ أكثر ويعالج أفضل.",
  "Tu fonces devant toi, intouchable, et les bad vibes alentour ne voient plus que toi.": "تندفع إلى الأمام لا يمسّك شيء، ولا ترى الـbad vibes من حولك أحدًا سواك.",
  "Tu gagnes 120 points de vie maximum.": "تكسب 120 نقطة صحة قصوى.",
  "Tu gagnes 40 points de vie maximum.": "تكسب 40 نقطة صحة قصوى.",
  "Tu gagnes 80 points de vie maximum.": "تكسب 80 نقطة صحة قصوى.",
  "Tu laisses les autres joueurs : ton personnage reste immobile et le set continue sans toi.": "تترك الآخرين: تبقى شخصيتك ثابتة وتستمر الحفلة من دونك.",
  "Tu libères une onde de lumière qui repousse les bad vibes autour de toi.": "تطلق موجة من الضوء تدفع الـbad vibes من حولك.",
  "Tu marches au stick droit et tu vises au gauche.": "تمشي بالعصا اليمنى وتصوّب باليسرى.",
  "Tu marches au stick gauche et tu vises au droit.": "تمشي بالعصا اليسرى وتصوّب باليمنى.",
  "Tu peux enchaîner deux dashs de plus.": "يمكنك ربط انقضاضين إضافيين.",
  "Tu peux enchaîner trois dashs de plus.": "يمكنك ربط ثلاثة انقضاضات إضافية.",
  "Tu peux enchaîner un dash de plus.": "يمكنك ربط انقضاض إضافي.",
  "Tu peux poser deux pièges de plus.": "يمكنك وضع فخّين إضافيين.",
  "Tu peux poser quatre pièges de plus.": "يمكنك وضع أربعة فخاخ إضافية.",
  "Tu peux poser six pièges de plus.": "يمكنك وضع ستة فخاخ إضافية.",
  "Tu ramasses les loots de bien plus loin.": "تلتقط الغنائم من مسافة أبعد بكثير.",
  "Tu ramasses les loots de plus loin.": "تلتقط الغنائم من مسافة أبعد.",
  "Tu ramasses les loots de très loin.": "تلتقط الغنائم من مسافة بعيدة جدًا.",
  "Tu rentres avant le sunrise : la partie s’arrête ici, sans score.": "تعود قبل الشروق: تنتهي المباراة هنا، بلا نقاط.",
  "Tu roules vite ; ta traînée freine les bad vibes et soigne.": "تسير بسرعة، وأثرك يُبطئ الـbad vibes ويعالج.",
  "Tu sais jouer. Tiens jusqu’au sunrise !": "أنت تعرف اللعب الآن. اصمد حتى الشروق!",
  "Tu soignes ceux qui sont près de toi et tu répares un peu la scène.": "تعالج من هم قربك وتصلح المسرح قليلًا.",
  "Tu te déplaces bien plus vite.": "تتحرك أسرع بكثير.",
  "Tu te déplaces nettement plus vite.": "تتحرك أسرع بوضوح.",
  "Tu te déplaces plus vite.": "تتحرك أسرع.",
  "Tu tires bien plus souvent.": "تطلق أكثر بكثير.",
  "Tu tires deux projectiles de plus.": "تطلق مقذوفين إضافيين.",
  "Tu tires nettement plus souvent.": "تطلق أكثر بوضوح.",
  "Tu tires plus souvent et ta spéciale revient plus vite.": "تطلق أكثر وتعود مهارتك الخاصة أسرع.",
  "Tu tires plus souvent.": "تطلق أكثر.",
  "Tu tires quatre projectiles de plus.": "تطلق أربعة مقذوفات إضافية.",
  "Tu tires six projectiles de plus.": "تطلق ستة مقذوفات إضافية.",
  "Un bâton, à jeter au feu": "حطبة، لتُرمى في النار",
  "Un cerceau tourne autour de toi, repousse et s’élargit.": "طوق يدور حولك، يدفع ويتّسع.",
  "Un joueur": "لاعب",
  "Un set, jusqu’au sunrise": "حفلة واحدة حتى الشروق",
  "Une brume qui te soigne": "ضباب يعالجك",
  "Une idée, un bug ? Dis-le-nous": "فكرة، خلل؟ أخبرنا",
  "Une note par coup porté": "نغمة لكل ضربة",
  "Une onde de choc par kick": "موجة صدمة على كل kick",
  "Une scène": "مسرح واحد",
  "Une vague part de toi, ralentit les bad vibes et fait courir et tirer plus vite toute l’équipe.": "تنطلق منك موجة تُبطئ الـbad vibes وتجعل الفريق كله يركض ويطلق أسرع.",
  "Ventilateur brumisant": "مروحة الرذاذ",
  "Verr. maj": "Caps Lock",
  "Vers la bad vibe à portée": "نحو الـbad vibe في المدى",
  "Vibes": "Vibes",
  "Vie": "الصحة",
  "Vie de la scène": "صحة المسرح",
  "Viser": "صوّب",
  "Viser et tirer": "صوّب وأطلق",
  "Visée automatique": "تصويب تلقائي",
  "Vitesse": "السرعة",
  "Volume à fond": "الصوت إلى الأقصى",
  "annuler": "إلغاء",
  "apprendre": "تعلُّم",
  "aucune": "لا شيء",
  "avant : {score}": "سابقًا: {score}",
  "avec {first} ou {second}, il fusionne": "مع {first} أو {second}، يندمج",
  "avec {upgrade}, devient {fusion}": "مع {upgrade}، يصبح {fusion}",
  "changer": "تغيير",
  "choisir": "اختيار",
  "classe": "الفئة",
  "classe, scène": "الفئة، المسرح",
  "départ {stage} · {count} scènes · {length}": "الانطلاق من {stage} · {count} مسارح · {length}",
  "fermer": "إغلاق",
  "lancer": "بدء",
  "mode": "الوضع",
  "naviguer": "تنقّل",
  "niv. {level}": "مستوى {level}",
  "ou rejoins le salon d’un ami": "أو انضم إلى غرفة صديق",
  "pose le piège à tes pieds": "ضع الفخ عند قدميك",
  "quitter": "مغادرة",
  "quitter sa place": "ترك المكان",
  "recharge {duration}": "إعادة الشحن {duration}",
  "rejoindre": "انضمام",
  "reprendre": "استئناف",
  "retour": "رجوع",
  "sans fin": "بلا نهاية",
  "scène": "المسرح",
  "son": "الصوت",
  "tant que vous tenez": "ما دمتم صامدين",
  "valider": "تأكيد",
  "vider": "إفراغ",
  "{action} : appuie sur un bouton de la manette.": "{action}: اضغط زرًا في يد التحكم.",
  "{action} : appuie sur une touche, un bouton de la souris ou la molette.": "{action}: اضغط مفتاحًا أو زر فأرة أو العجلة.",
  "{action} : case vidée.": "{action}: أُفرغت الخانة.",
  "{action}, touche {number} : {key}": "{action}، الخانة {number}: {key}",
  "{count} alliés soignés": {
    "zero": "لا حلفاء مُعالَجين",
    "one": "حليف مُعالَج واحد",
    "two": "حليفان مُعالَجان",
    "few": "{count} حلفاء مُعالَجين",
    "many": "{count} حليفًا مُعالَجًا",
    "other": "{count} حليف مُعالَج"
  },
  "{count} bad vibes": {
    "zero": "{count} bad vibes",
    "one": "{count} bad vibe",
    "two": "{count} bad vibes",
    "few": "{count} bad vibes",
    "many": "{count} bad vibes",
    "other": "{count} bad vibes"
  },
  "{count} boss": {
    "zero": "لا زعماء",
    "one": "زعيم واحد",
    "two": "زعيمان",
    "few": "{count} زعماء",
    "many": "{count} زعيمًا",
    "other": "{count} زعيم"
  },
  "{count} cartes": {
    "zero": "لا بطاقات",
    "one": "بطاقة واحدة",
    "two": "بطاقتان",
    "few": "{count} بطاقات",
    "many": "{count} بطاقة",
    "other": "{count} بطاقة"
  },
  "{count} vibes": {
    "zero": "{count} vibes",
    "one": "{count} vibe",
    "two": "{count} vibes",
    "few": "{count} vibes",
    "many": "{count} vibes",
    "other": "{count} vibes"
  },
  "{count} visites": {
    "zero": "لا زيارات",
    "one": "زيارة واحدة",
    "two": "زيارتان",
    "few": "{count} زيارات",
    "many": "{count} زيارة",
    "other": "{count} زيارة"
  },
  "{hp} sur {maxHp}": "{hp} من {maxHp}",
  "{key} va à {action} et quitte {other}.": "{key} ينتقل إلى {action} ويترك {other}.",
  "{key} va à {action}, {other} prend {old}.": "{key} ينتقل إلى {action}، و{other} يأخذ {old}.",
  "{key} va à {action}.": "{key} ينتقل إلى {action}.",
  "{names} et {last}": "{names} و{last}",
  "{name} : {card}": "{name}: {card}",
  "{name} : {description}": "{name}: {description}",
  "{name} a quitté le set": "غادر {name} الحفلة",
  "{name} choisit…": "{name} يختار…",
  "{name}, dans le jeu complet": "{name}، في اللعبة الكاملة",
  "{percent} %": "{percent}%",
  "{percent} %": "{percent}%",
  "{plugged} enceintes branchées sur {total}": {
    "zero": "لا مكبرات موصولة من {total}",
    "one": "مكبر واحد موصول من {total}",
    "two": "مكبران موصولان من {total}",
    "few": "{plugged} مكبرات موصولة من {total}",
    "many": "{plugged} مكبرًا موصولًا من {total}",
    "other": "{plugged} مكبر موصول من {total}"
  },
  "{role}, que tes agrès ne font pas encore": "{role}، وهو ما لا تفعله أدواتك بعد",
  "{skill} : en recharge": "{skill}: قيد الشحن",
  "{skill} : prête": "{skill}: جاهزة",
  "{taken}/{capacity}": "{taken}/{capacity}",
  "{value} sur {max}": "{value} من {max}",
  "{weapon} + {upgrade}": "{weapon} + {upgrade}",
  "{weapon}, niveau {level}": "{weapon}، المستوى {level}",
  "À distance": "عن بُعد",
  "À fond": "ممتلئ",
  "À plusieurs": "مع الأصدقاء",
  "À terre": "ساقط",
  "Échap": "Esc",
  "Éclats de rire": "قهقهات",
  "Écran titre": "الشاشة الرئيسية",
  "Écris ton avis avant de l’envoyer.": "اكتب رأيك قبل إرساله.",
  "Équilibrage": "التوازن",
  "Éventails de feu": "مراوح النار",
  "≈ {minutes} min": "≈ {minutes} د"
}
